import React from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {useParams} from 'react-router-dom';
import UpdateSingleVoyage from "@containers/singleVoyage/mutateVoyage/updateVoyage/UpdateSingleVoyage";

const UpdateSingleVoyagePage = () => {
    const {voyageId} = useParams()
    return (
        <PageLayout>
            <UpdateSingleVoyage
                voyageId={Number(voyageId)}
            />
        </PageLayout>
    );
};

export default UpdateSingleVoyagePage;
